import { Payload, Types } from 'states/dux/nivos-news/types'
import { Action } from 'states/types'

const initialState: Payload = {
  loading: true,
  data: []
}

const reducer = (state = initialState, action: Action<Payload>): Payload => {
  const { type, payload } = action
  switch (type) {
    case Types.SET: {
      return payload
    }
    case Types.ADD: {
      const data = [...state.data]
      data.push(payload.data[0])

      return { ...state, data }
    }
    case Types.UPDATE: {
      const newStateData = state.data.map(element => {
        if (element.id === payload.data[0].id) {
          return payload.data[0]
        }
        return element
      })

      return { ...state, data: newStateData }
    }
    case Types.DELETE: {
      const newStateData = state.data.filter(
        element => element.id !== payload.data[0].id
      )

      return { ...state, data: newStateData }
    }
    case Types.LOADING: {
      return { ...state, loading: payload.loading }
    }
    default:
      return state
  }
}

export { reducer }

export default reducer
